<div class="main-container" [class.filters-expanded]="isMobileFiltersExpanded" [style.--actual-viewport-height.px]="actualViewportHeight">
  <mat-toolbar class="p-0 mat-elevation-z1" style="margin-bottom: 10px;">
    <div style="margin-left: 15px;">
      <a href="/"> <h3>{{'ecase.common.generalDirectory.home' | translate}}</h3></a>
    </div>
    <div fxFill fxFlex fxLayout="row" fxLayoutAlign="end center">

      <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
        <ng-container>
          <div class="toolbar-separator"></div>
          <button [matMenuTriggerFor]="languageMenu" class="language-button"
                  fxShow.gt-xs
                  mat-button>
            <div fxLayout="row" fxLayoutAlign="center center">
              <span class="iso text-uppercase">{{selectedLang}}</span>
            </div>
          </button>

          <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
            <ng-container *ngFor="let lang of languages">
              <button (click)="setLanguage(lang)" [disabled]="lang.id === selectedLang.id" mat-menu-item>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <span class="iso">{{lang.nativeName}}</span>
                </div>
              </button>
            </ng-container>
          </mat-menu>
        </ng-container>
      </div>
    </div>
  </mat-toolbar>

  <p *ngIf="'ecase.common.generalDirectory.info' | eCaseTranslate as infoText" class="accessibility-info" [innerHTML]="infoText"></p>

  <button
    *ngIf="isMobileView"
    class="mobile-filter-toggle"
    [class.expanded]="isMobileFiltersExpanded"
    (click)="toggleMobileFilters()"
    type="button"
    aria-label="Toggle filters">
    <div class="toggle-content">
              <div>
          <mat-icon>filter_list</mat-icon>
          <span>{{'ecase.common.generalDirectory.filters' | translate}}</span>
          <span *ngIf="hasActiveFilters()" class="filter-count">{{ getActiveFilterCount() }}</span>
        </div>
      <mat-icon>expand_more</mat-icon>
    </div>
  </button>

  <mat-expansion-panel
    *ngIf="!isMobileView"
    [expanded]="isFilterPanelExpanded"
    (opened)="isFilterPanelExpanded = true"
    (closed)="isFilterPanelExpanded = false; onPanelClosed()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>filter_list</mat-icon>
        {{'ecase.common.generalDirectory.filters' | translate}}
        <span *ngIf="hasActiveFilters()" class="filter-status">
          <mat-icon class="filter-active-icon">check_circle</mat-icon>
          ({{ getActiveFilterCount() }})
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="filter-section" [formGroup]="form">
      <div *ngIf="filtersLoading" class="filters-loading">
        <app-loading-spinner></app-loading-spinner>
      </div>

      <div *ngIf="!filtersLoading" class="filter-content-wrapper">
        <div class="filter-content">
          <div class="search-section">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>{{'ecase.common.generalDirectory.searchAward' | translate}}</mat-label>
              <input matInput
                     formControlName="searchAwardNameOrId"
                     (input)="onSearchChange($event)"
                     [placeholder]="'ecase.common.generalDirectory.searchAward' | translate">
            </mat-form-field>
          </div>
          <div class="filter-columns">
            <div class="filter-column">
              <div class="filter-group">
                <h4 [matTooltip]="facultyLabelTooltip">
                  {{ facultyLabel }}
                  <span *ngIf="form.get('faculty').value?.length" class="selection-count">
                    ({{ form.get('faculty').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="facultyLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="faculty" multiple (selectionChange)="onFilterChange($event, 'faculty')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + facultyLabel">
                    <mat-option *ngFor="let faculty of faculties" [value]="faculty.id" [matTooltip]="faculty.tooltip">
                      {{ faculty.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <h4 [matTooltip]="programLabelTooltip">
                  {{ programLabel }}
                  <span *ngIf="form.get('program').value?.length" class="selection-count">
                    ({{ form.get('program').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="programLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="program" multiple (selectionChange)="onFilterChange($event, 'program')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + programLabel" [disabled]="filteredPrograms.length === 0">
                    <mat-option *ngFor="let program of filteredPrograms" [value]="program.id" [matTooltip]="program.tooltip">
                      {{ program.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="filter-column">
              <div class="filter-group">
                <h4 [matTooltip]="levelLabelTooltip">
                  {{ levelLabel }}
                  <span *ngIf="form.get('level').value?.length" class="selection-count">
                    ({{ form.get('level').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="levelLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="level" multiple (selectionChange)="onFilterChange($event, 'level')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + levelLabel">
                    <mat-option *ngFor="let level of levels" [value]="level.id" [matTooltip]="level.tooltip">
                      {{ level.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <h4 [matTooltip]="stageLabelTooltip">
                  {{ stageLabel }}
                  <span *ngIf="form.get('stage').value?.length" class="selection-count">
                    ({{ form.get('stage').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="stageLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="stage" multiple (selectionChange)="onFilterChange($event, 'stage')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + stageLabel">
                    <mat-option *ngFor="let stage of stages" [value]="stage.id" [matTooltip]="stage.tooltip">
                      {{ stage.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="filter-column">
              <div class="filter-group">
                <h4 [matTooltip]="legalStatusLabelTooltip">
                  {{ legalStatusLabel }}
                  <span *ngIf="form.get('legalStatus').value?.length" class="selection-count">
                    ({{ form.get('legalStatus').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="legalStatusLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="legalStatus" multiple (selectionChange)="onFilterChange($event, 'legalStatus')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + legalStatusLabel">
                    <mat-option *ngFor="let status of legalStatuses" [value]="status.id" [matTooltip]="status.tooltip">
                      {{ status.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <h4 [matTooltip]="applicationRequirementLabelTooltip">
                  {{ applicationRequirementLabel }}
                  <span *ngIf="form.get('applicationRequirement').value?.length" class="selection-count">
                    ({{ form.get('applicationRequirement').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="applicationRequirementLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="applicationRequirement" multiple (selectionChange)="onFilterChange($event, 'applicationRequirement')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + applicationRequirementLabel">
                    <mat-option *ngFor="let req of applicationRequirements" [value]="req.id" [matTooltip]="req.tooltip">
                      {{ req.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="filter-column">
              <div class="filter-group">
                <h4 [matTooltip]="residencyLabelTooltip">
                  {{ residencyLabel }}
                  <span *ngIf="form.get('residency').value?.length" class="selection-count">
                    ({{ form.get('residency').value.length }} selected)
                  </span>
                  <mat-icon *ngIf="residencyLabelTooltip" class="help-icon">help_outline</mat-icon>
                </h4>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="residency" multiple (selectionChange)="onFilterChange($event, 'residency')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + residencyLabel">
                    <mat-option *ngFor="let residency of residencies" [value]="residency.id" [matTooltip]="residency.tooltip">
                      {{ residency.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="checkbox-groups">
            <div class="checkbox-section">
              <h4 [matTooltip]="accessLabelTooltip">
                {{ accessLabel }}
                <mat-icon *ngIf="accessLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <div class="checkbox-grid">
                <mat-checkbox
                  *ngFor="let option of accessOptions"
                  [checked]="isOptionSelected(option.id)"
                  (change)="onCheckboxChange($event, option.id)"
                  [matTooltip]="option.tooltip">
                  {{ option.label }}
                  <mat-icon *ngIf="option.tooltip" class="help-icon">help_outline</mat-icon>
                </mat-checkbox>
              </div>
            </div>

            <div class="checkbox-section">
              <h4 [matTooltip]="miscLabelTooltip">
                {{ miscLabel }}
                <mat-icon *ngIf="miscLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <div class="checkbox-grid">
                <mat-checkbox
                  *ngFor="let option of miscOptions"
                  [checked]="isOptionSelected(option.id)"
                  (change)="onCheckboxChange($event, option.id)"
                  [matTooltip]="option.tooltip">
                  {{ option.label }}
                  <mat-icon *ngIf="option.tooltip" class="help-icon">help_outline</mat-icon>
                </mat-checkbox>
              </div>
            </div>
          </div>

          <div class="filter-actions">
            <button mat-raised-button color="primary" (click)="applyFilters()" [disabled]="(!pendingFilterChanges && !hasActiveFilters()) || loading">
              <mat-icon *ngIf="!loading">filter_list</mat-icon>
              <mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
              {{'ecase.common.generalDirectory.applyFilters' | translate}} ({{ getActiveFilterCount() }})
            </button>
            <button mat-stroked-button (click)="clearFilters()" [disabled]="(!pendingFilterChanges && !hasActiveFilters()) || loading">
              <mat-icon *ngIf="!loading">clear</mat-icon>
              <mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
              {{'ecase.common.generalDirectory.clearFilters' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>

  <div
    *ngIf="isMobileView"
    class="filter-section"
    [class.filters-expanded]="isMobileFiltersExpanded"
    [formGroup]="form">

    <div *ngIf="filtersLoading" class="filters-loading">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <div *ngIf="!filtersLoading" class="filter-content-wrapper">
      <div class="filter-header" *ngIf="isMobileFiltersExpanded">
        <h3>{{'ecase.common.generalDirectory.filters' | translate}}</h3>
        <button
          class="close-filter-btn"
          (click)="closeMobileFilters()"
          type="button"
          aria-label="Close filters">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="filter-content">
        <h3 *ngIf="!isMobileFiltersExpanded">{{'ecase.common.generalDirectory.filters' | translate}}</h3>

        <div class="search-section">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{'ecase.common.generalDirectory.searchAward' | translate}}</mat-label>
            <input matInput
                   formControlName="searchAwardNameOrId"
                   (input)="onSearchChange($event)"
                   [placeholder]="'ecase.common.generalDirectory.searchAward' | translate">
          </mat-form-field>
        </div>

        <div class="filter-columns">
          <div class="filter-column">
            <div class="filter-group">
              <h4 [matTooltip]="facultyLabelTooltip">
                {{ facultyLabel }}
                <span *ngIf="form.get('faculty').value?.length" class="selection-count">
                  ({{ form.get('faculty').value.length }} selected)
                </span>
                <mat-icon *ngIf="facultyLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="faculty" multiple (selectionChange)="onFilterChange($event, 'faculty')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + facultyLabel">
                  <mat-option *ngFor="let faculty of faculties" [value]="faculty.id" [matTooltip]="faculty.tooltip">
                    {{ faculty.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <h4 [matTooltip]="programLabelTooltip">
                {{ programLabel }}
                <span *ngIf="form.get('program').value?.length" class="selection-count">
                  ({{ form.get('program').value.length }} selected)
                </span>
                <mat-icon *ngIf="programLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="program" multiple (selectionChange)="onFilterChange($event, 'program')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + programLabel" [disabled]="filteredPrograms.length === 0">
                  <mat-option *ngFor="let program of filteredPrograms" [value]="program.id" [matTooltip]="program.tooltip">
                    {{ program.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-column">
            <div class="filter-group">
              <h4 [matTooltip]="levelLabelTooltip">
                {{ levelLabel }}
                <span *ngIf="form.get('level').value?.length" class="selection-count">
                  ({{ form.get('level').value.length }} selected)
                </span>
                <mat-icon *ngIf="levelLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="level" multiple (selectionChange)="onFilterChange($event, 'level')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + levelLabel">
                  <mat-option *ngFor="let level of levels" [value]="level.id" [matTooltip]="level.tooltip">
                    {{ level.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <h4 [matTooltip]="stageLabelTooltip">
                {{ stageLabel }}
                <span *ngIf="form.get('stage').value?.length" class="selection-count">
                  ({{ form.get('stage').value.length }} selected)
                </span>
                <mat-icon *ngIf="stageLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="stage" multiple (selectionChange)="onFilterChange($event, 'stage')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + stageLabel">
                  <mat-option *ngFor="let stage of stages" [value]="stage.id" [matTooltip]="stage.tooltip">
                    {{ stage.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-column">
            <div class="filter-group">
              <h4 [matTooltip]="legalStatusLabelTooltip">
                {{ legalStatusLabel }}
                <span *ngIf="form.get('legalStatus').value?.length" class="selection-count">
                  ({{ form.get('legalStatus').value.length }} selected)
                </span>
                <mat-icon *ngIf="legalStatusLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="legalStatus" multiple (selectionChange)="onFilterChange($event, 'legalStatus')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + legalStatusLabel">
                  <mat-option *ngFor="let status of legalStatuses" [value]="status.id" [matTooltip]="status.tooltip">
                    {{ status.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <h4 [matTooltip]="applicationRequirementLabelTooltip">
                {{ applicationRequirementLabel }}
                <span *ngIf="form.get('applicationRequirement').value?.length" class="selection-count">
                  ({{ form.get('applicationRequirement').value.length }} selected)
                </span>
                <mat-icon *ngIf="applicationRequirementLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="applicationRequirement" multiple (selectionChange)="onFilterChange($event, 'applicationRequirement')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + applicationRequirementLabel">
                  <mat-option *ngFor="let req of applicationRequirements" [value]="req.id" [matTooltip]="req.tooltip">
                    {{ req.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-column">
            <div class="filter-group">
              <h4 [matTooltip]="residencyLabelTooltip">
                {{ residencyLabel }}
                <span *ngIf="form.get('residency').value?.length" class="selection-count">
                  ({{ form.get('residency').value.length }} selected)
                </span>
                <mat-icon *ngIf="residencyLabelTooltip" class="help-icon">help_outline</mat-icon>
              </h4>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select formControlName="residency" multiple (selectionChange)="onFilterChange($event, 'residency')" [placeholder]="(selectedLang === 'fr' ? 'Sélectionner ' : 'Select ') + residencyLabel">
                  <mat-option *ngFor="let residency of residencies" [value]="residency.id" [matTooltip]="residency.tooltip">
                    {{ residency.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="checkbox-groups">
          <div class="checkbox-section">
            <h4 [matTooltip]="accessLabelTooltip">
              {{ accessLabel }}
              <mat-icon *ngIf="accessLabelTooltip" class="help-icon">help_outline</mat-icon>
            </h4>
            <div class="checkbox-grid">
              <mat-checkbox
                *ngFor="let option of accessOptions"
                [checked]="isOptionSelected(option.id)"
                (change)="onCheckboxChange($event, option.id)"
                [matTooltip]="option.tooltip">
                {{ option.label }}
                <mat-icon *ngIf="option.tooltip" class="help-icon">help_outline</mat-icon>
              </mat-checkbox>
            </div>
          </div>

          <div class="checkbox-section">
            <h4 [matTooltip]="miscLabelTooltip">
              {{ miscLabel }}
              <mat-icon *ngIf="miscLabelTooltip" class="help-icon">help_outline</mat-icon>
            </h4>
            <div class="checkbox-grid">
              <mat-checkbox
                *ngFor="let option of miscOptions"
                [checked]="isOptionSelected(option.id)"
                (change)="onCheckboxChange($event, option.id)"
                [matTooltip]="option.tooltip">
                {{ option.label }}
                <mat-icon *ngIf="option.tooltip" class="help-icon">help_outline</mat-icon>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-actions">
        <button mat-raised-button color="primary" (click)="applyFilters()" [disabled]="(!pendingFilterChanges && !hasActiveFilters()) || loading">
          <mat-icon *ngIf="!loading">filter_list</mat-icon>
          <mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
          {{'ecase.common.generalDirectory.applyFilters' | translate}} ({{ getActiveFilterCount() }})
        </button>
        <button mat-stroked-button (click)="clearFilters()" [disabled]="(!pendingFilterChanges && !hasActiveFilters()) || loading">
          <mat-icon *ngIf="!loading">clear</mat-icon>
          <mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
          {{'ecase.common.generalDirectory.clearFilters' | translate}}
        </button>
      </div>
    </div>
  </div>

  <mat-card class="result-panel">
    <mat-card-title>{{'ecase.opportunity.listofavaialbleopportunities' | eCaseTranslate }}</mat-card-title>


    <div class="mobile-controls" *ngIf="isMobileView">
      <div class="mobile-sort">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{'ecase.common.generalDirectory.sortBy' | translate}}</mat-label>
          <mat-select (selectionChange)="onMobileSortChange($event)" [value]="selectedSortOption">
            <mat-option *ngFor="let option of mobileSortOptions" [value]="option">
              {{ option.label | eCaseTranslate }} ({{ option.direction === 'asc' ? 'A-Z' : 'Z-A' }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="table-container">
      <div *ngIf="loading" class="table-loading">
        <app-loading-spinner></app-loading-spinner>
      </div>

      <div class="desktop-view" *ngIf="!isMobileView && !loading">
        <div class="table-scroll-container">
          <table mat-table [dataSource]="competitions" class="mat-elevation-z1 scholarship-table" matSort (matSortChange)="onSortChange($event)" matSortActive="{{sortBy}}" matSortDirection="{{sortOrder}}">

            <ng-container matColumnDef="awardName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="awardName"> {{'ecase.opportunity.programName' | eCaseTranslate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.displayProgramName }} </td>
            </ng-container>

            <ng-container matColumnDef="competition">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="competition"> {{'ecase.common.generalDirectory.competitionName' | eCaseTranslate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.displayCompetitionName }} </td>
            </ng-container>

            <ng-container matColumnDef="openDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="openDate"> {{'ecase.opportunity.accessDate' | eCaseTranslate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.formattedOpenDate }} </td>
            </ng-container>

            <ng-container matColumnDef="deadline">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="deadline"> {{'ecase.opportunity.deadlineForSubmission' | eCaseTranslate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.formattedDeadline }} </td>
            </ng-container>

            <ng-container matColumnDef="details">
              <th mat-header-cell *matHeaderCellDef> {{'ecase.opportunity.prospectus' | eCaseTranslate}} </th>
              <td mat-cell *matCellDef="let element">
                <a [href]="element.displayUrl" target="_blank" [matTooltip]="'ecase.common.generalDirectory.viewDetails' | translate" (click)="onAwardDetailsClick(element, $event)">
                  <mat-icon>open_in_new</mat-icon>
                </a>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>

      <div class="mobile-view" *ngIf="isMobileView && !loading">
        <div class="mobile-cards">
          <mat-card *ngFor="let competition of competitions" class="competition-card">
            <mat-card-header>
              <mat-card-title class="award-name">{{ competition.displayProgramName }}</mat-card-title>
              <mat-card-subtitle class="competition-name">{{ competition.displayCompetitionName }}</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="date-info">
                <div class="date-item">
                  <span class="date-label">{{'ecase.opportunity.accessDate' | eCaseTranslate}}</span>
                  <span class="date-value">{{ competition.formattedOpenDate }}</span>
                </div>
                <div class="date-item">
                  <span class="date-label">{{'ecase.opportunity.deadlineForSubmission' | eCaseTranslate}}</span>
                  <span class="date-value">{{ competition.formattedDeadline }}</span>
                </div>
              </div>
            </mat-card-content>

            <mat-card-actions align="end">
              <a [href]="competition.displayUrl" target="_blank" mat-raised-button color="primary" (click)="onAwardDetailsClick(competition, $event)">
                <mat-icon>open_in_new</mat-icon>
                {{'ecase.common.generalDirectory.viewDetails' | translate}}
              </a>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>

    <div class="pagination-wrapper" *ngIf="!loading">
      <mat-paginator
        [length]="totalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="currentPage"
        (page)="onPageChange($event)"
        [showFirstLastButtons]="true"
        [hidePageSize]="isMobileView"
        aria-label="Select page of competitions">
      </mat-paginator>
    </div>
  </mat-card>
</div>
